module.exports = __webpack_public_path__ + "static/media/iso-9001-rgb.ff25ef12.jpg";